import { SetupNative2faFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";
import { MfaCodeStrategy } from "@towersystems/roam-common/lib/generated-types";
import { schema } from "./constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { useEffect } from "react";

export interface SetupNative2faFormProviderProps {
  children?: React.ReactNode;
}

export const DEFAULT_STRATEGIES = [MfaCodeStrategy.EMAIL, MfaCodeStrategy.SMS];

export const SetupNative2faFormProvider = ({
  children,
}: SetupNative2faFormProviderProps) => {
  const { user } = useAuthenticationProvider();

  const methods = useForm<SetupNative2faFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ui: {
        codeSent: false,
        strategies: getStrategies(),
      },
      data: {
        strategy: undefined,
        code: undefined,
      },
    },
    resolver: yupResolver(schema),
  });

  function getStrategies() {
    return DEFAULT_STRATEGIES.filter((strategy) => {
      return !user?.mfaMethods.find(
        (i) => i.verified === true && i.strategy === strategy
      );
    });
  }

  useEffect(() => {
    if (!user) return;

    console.log("Updating strategies in 2FA setup form", getStrategies());

    methods.setValue("ui.strategies", getStrategies());
  }, [JSON.stringify(user?.mfaMethods || [])]);

  return <FormProvider {...methods}>{children}</FormProvider>;
};
